import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useUser } from "#/hooks/use-user";
import { useAuth } from "#hooks/use-auth.jsx";
import AccountSettingsCard from "./AccountSettingsCard";
import { jsx as _jsx } from "react/jsx-runtime";
export function AccountSettingsView(t0) {
  const $ = _c(18);
  const {
    authClient,
    user,
    onSignOut,
    onBack,
    onEditProfile,
    onChangePassword,
    onChangeEmail,
    onDeleteAccount,
    statusMessage: initialStatusMessage,
    onStatusMessageAction
  } = t0;
  let t1;
  if ($[0] !== authClient) {
    t1 = {
      authClient
    };
    $[0] = authClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isUpdating
  } = useUser(t1);
  let t2;
  if ($[2] !== authClient) {
    t2 = {
      authClient
    };
    $[2] = authClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    signOut
  } = useAuth(t2);
  const [statusMessage, setStatusMessage] = useState(initialStatusMessage);
  let t3;
  if ($[4] !== onSignOut || $[5] !== signOut) {
    t3 = async () => {
      const response = await signOut();
      if (response.success) {
        await onSignOut();
      } else {
        setStatusMessage({
          message: response.message,
          variant: "error"
        });
      }
      return response;
    };
    $[4] = onSignOut;
    $[5] = signOut;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSignOut = t3;
  let t4;
  if ($[7] !== handleSignOut || $[8] !== isUpdating || $[9] !== onBack || $[10] !== onChangeEmail || $[11] !== onChangePassword || $[12] !== onDeleteAccount || $[13] !== onEditProfile || $[14] !== onStatusMessageAction || $[15] !== statusMessage || $[16] !== user) {
    t4 = /*#__PURE__*/_jsx(AccountSettingsCard, {
      user: user,
      onSignOut: handleSignOut,
      onBack: onBack,
      onEditProfile: onEditProfile,
      onChangePassword: onChangePassword,
      onChangeEmail: onChangeEmail,
      onDeleteAccount: onDeleteAccount,
      statusMessage: statusMessage,
      onStatusMessageAction: onStatusMessageAction,
      isLoading: isUpdating
    });
    $[7] = handleSignOut;
    $[8] = isUpdating;
    $[9] = onBack;
    $[10] = onChangeEmail;
    $[11] = onChangePassword;
    $[12] = onDeleteAccount;
    $[13] = onEditProfile;
    $[14] = onStatusMessageAction;
    $[15] = statusMessage;
    $[16] = user;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}